import React, { Component } from "react";
import { Alert, Button, Table, Spinner } from "react-bootstrap";

class LWOCryptBlock extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: {
                winxp: false,
                win_x64: false,
                win_x86: false,
                linux_glibc: false,
                linux_musl: false,
                macos_arm64: false,
                macos_arm64e: false,
                macos_x86_64: false,
                ios_tescrypto: false,
                ios_frameworks: false,
                ios_libs: false,
                android_test_apk: false,
                android_aar: false,
                android_prj_aar: false,
                android_example_prj_aar: false,
            }

        }
        this.onClickLWOCryptDownload = this.onClickLWOCryptDownload.bind(this);
    }

    onClickLWOCryptDownload(e, system) {
        this.setState({
            isLoading: {
                ...this.state.isLoading,
                [system]: true
            }
        })
        this.props.onClickLWOCryptDownload(e).then(() => {
            this.setState({
                isLoading: {
                    ...this.state.isLoading,
                    [system]: false
                }
            })
        }).catch(() => {
            this.setState({
                isLoading: {
                    ...this.state.isLoading,
                    [system]: false
                }
            })
        })
    }

    render() {
        return (

            <Alert style={{ width: '100%', cursor: 'pointer' }} variant="light">
                <div onClick={this.props.blockLWOCryptIsOpen ? this.props.closeBlockLWOCrypt : this.props.openBlockLWOCrypt}
                    style={{ display: "flex", height: this.props.blockLWOCryptIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "55%" }}>
                        <div style={{ color: "black" }}>  LWOCrypt 3.0.0 </div>

                    </div>
                    <div style={{ width: "45%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockLWOCryptIsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>

                </div>

                {
                    this.props.blockLWOCryptIsOpen ? <div>
                        <div style={{ borderBottom: !this.props.blockLDDWinIsOpen ? "1px solid #e3e3e3" : null }} />

                        <Alert style={{ width: '100%', cursor: 'pointer', padding: "0.75rem 0", margin: "0" }} variant="light">
                            <div onClick={this.props.blockLWOCryptWinIsOpen ? this.props.closeBlockLWOCryptWin : this.props.openBlockLWOCryptWin}
                                style={{ display: "flex", height: this.props.blockLWOCryptWinIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                                <div style={{ width: "55%" }}>
                                    <div style={{ color: "black" }}>Windows</div>
                                </div>
                                <div style={{ width: "45%" }}>
                                    <b style={{ color: "black", float: "right" }}>
                                        {this.props.blockLWOCryptWinIsOpen ?
                                            <div >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                            </div> :
                                            <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                                        }
                                    </b>
                                </div>

                            </div>

                            {
                                this.props.blockLWOCryptWinIsOpen ? <div>
                                    <Table striped style={{ animation: "fadeIn 1s" }}  >
                                        <tbody>
                                            <tr>
                                                <td>XP </td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="LWOCrypt Installer XP.exe"
                                                        value="win"
                                                        disabled={this.state.isLoading.winxp}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'winxp')}>
                                                        {!this.state.isLoading.winxp ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>

                                                </td>

                                            </tr>
                                            <tr>
                                                <td>x64 </td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="LWOCrypt Installer x64.exe"
                                                        value="win"
                                                        disabled={this.state.isLoading.win_x64}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'win_x64')}>
                                                        {!this.state.isLoading.win_x64 ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>

                                                </td>

                                            </tr>
                                            <tr>
                                                <td>x32</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="LWOCrypt Installer x86.exe"
                                                        value="win"
                                                        disabled={this.state.isLoading.win_x86}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'win_x86')}>
                                                        {!this.state.isLoading.win_x86 ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>

                                                </td>

                                            </tr>
                                        </tbody>
                                    </Table>
                                </div> : null
                            }
                        </Alert>
                        <div style={{ borderBottom: !this.props.blockLDDWinIsOpen ? "1px solid #e3e3e3" : null }} />
                        <Alert style={{ width: '100%', cursor: 'pointer', padding: "0.75rem 0", margin: "0" }} variant="light">
                            <div onClick={this.props.blockLWOCryptLinuxIsOpen ? this.props.closeBlockLWOCryptLinux : this.props.openBlockLWOCryptLinux}
                                style={{ display: "flex", height: this.props.blockLWOCryptLinuxIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                                <div style={{ width: "55%" }}>
                                    <div style={{ color: "black" }}>Linux</div>
                                </div>
                                <div style={{ width: "45%" }}>
                                    <b style={{ color: "black", float: "right" }}>
                                        {this.props.blockLWOCryptLinuxIsOpen ?
                                            <div >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                            </div> :
                                            <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                                        }
                                    </b>
                                </div>

                            </div>

                            {
                                this.props.blockLWOCryptLinuxIsOpen ? <div>
                                    <Table striped style={{ animation: "fadeIn 1s" }}  >
                                        <tbody>
                                            <tr>
                                                <td>glibc</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="glibc.tar.gz"
                                                        value="linux"
                                                        disabled={this.state.isLoading.linux_glibc}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'linux_glibc')}>
                                                        {!this.state.isLoading.linux_glibc ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>

                                                </td>

                                            </tr>
                                            <tr>
                                                <td>musl </td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="musl.tar.gz"
                                                        value="linux"
                                                        disabled={this.state.isLoading.linux_musl}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'linux_musl')}>
                                                        {!this.state.isLoading.linux_musl ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div> : null
                            }
                        </Alert>
                        <div style={{ borderBottom: !this.props.blockLDDWinIsOpen ? "1px solid #e3e3e3" : null }} />
                        <Alert style={{ width: '100%', cursor: 'pointer', padding: "0.75rem 0", margin: "0" }} variant="light">
                            <div onClick={this.props.blockLWOCryptMacIsOpen ? this.props.closeBlockLWOCryptMac : this.props.openBlockLWOCryptMac}
                                style={{ display: "flex", height: this.props.blockLWOCryptMacIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                                <div style={{ width: "55%" }}>
                                    <div style={{ color: "black" }}>MacOS</div>
                                </div>
                                <div style={{ width: "45%" }}>
                                    <b style={{ color: "black", float: "right" }}>
                                        {this.props.blockLWOCryptMacIsOpen ?
                                            <div >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                            </div> :
                                            <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                                        }
                                    </b>
                                </div>

                            </div>

                            {
                                this.props.blockLWOCryptMacIsOpen ? <div>
                                    <Table striped style={{ animation: "fadeIn 1s" }}  >
                                        <tbody>
                                            <tr>
                                                <td>arm64 </td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="arm64.zip"
                                                        value="macos"
                                                        disabled={this.state.isLoading.macos_arm64}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'macos_arm64')}>
                                                        {!this.state.isLoading.macos_arm64 ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>arm64e</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="arm64e.zip"
                                                        value="macos"
                                                        disabled={this.state.isLoading.macos_arm64e}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'macos_arm64e')}>
                                                        {!this.state.isLoading.macos_arm64e ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>x86_64</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="x86_64.zip"
                                                        value="macos"
                                                        disabled={this.state.isLoading.macos_x86_64}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'macos_x86_64')}>
                                                        {!this.state.isLoading.macos_x86_64 ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div> : null
                            }
                        </Alert>
                        <div style={{ borderBottom: !this.props.blockLDDWinIsOpen ? "1px solid #e3e3e3" : null }} />
                        <Alert style={{ width: '100%', cursor: 'pointer', padding: "0.75rem 0", margin: "0" }} variant="light">
                            <div onClick={this.props.blockLWOCryptIOSIsOpen ? this.props.closeBlockLWOCryptIOS : this.props.openBlockLWOCryptIOS}
                                style={{ display: "flex", height: this.props.blockLWOCryptIOSIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                                <div style={{ width: "55%" }}>
                                    <div style={{ color: "black" }}>IOS</div>
                                </div>
                                <div style={{ width: "45%" }}>
                                    <b style={{ color: "black", float: "right" }}>
                                        {this.props.blockLWOCryptIOSIsOpen ?
                                            <div >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                            </div> :
                                            <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                                        }
                                    </b>
                                </div>

                            </div>

                            {
                                this.props.blockLWOCryptIOSIsOpen ? <div>
                                    <Table striped style={{ animation: "fadeIn 1s" }}  >
                                        <tbody>
                                            <tr>
                                                <td>Тестовое приложение</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="testcrypto.zip"
                                                        value="ios"
                                                        disabled={this.state.isLoading.ios_tescrypto}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'ios_tescrypto')}>
                                                        {!this.state.isLoading.ios_tescrypto ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Frameworks</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="Frameworks_ios.zip"
                                                        value="ios"
                                                        disabled={this.state.isLoading.ios_frameworks}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'ios_frameworks')}>
                                                        {!this.state.isLoading.ios_frameworks ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Библиотеки</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="libs_ios.zip"
                                                        value="ios"
                                                        disabled={this.state.isLoading.ios_libs}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'ios_libs')}>
                                                        {!this.state.isLoading.ios_libs ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div> : null
                            }
                        </Alert>
                        <div style={{ borderBottom: !this.props.blockLDDWinIsOpen ? "1px solid #e3e3e3" : null }} />
                        <Alert style={{ width: '100%', cursor: 'pointer', padding: "0.75rem 0", margin: "0" }} variant="light">
                            <div onClick={this.props.blockLWOCryptAndroidIsOpen ? this.props.closeBlockLWOCryptAndroid : this.props.openBlockLWOCryptAndroid}
                                style={{ display: "flex", height: this.props.blockLWOCryptAndroidIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                                <div style={{ width: "55%" }}>
                                    <div style={{ color: "black" }}>Android</div>
                                </div>
                                <div style={{ width: "45%" }}>
                                    <b style={{ color: "black", float: "right" }}>
                                        {this.props.blockLWOCryptAndroidIsOpen ?
                                            <div >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                            </div> :
                                            <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                                        }
                                    </b>
                                </div>

                            </div>
                            {
                                this.props.blockLWOCryptAndroidIsOpen ? <div>
                                    <Table striped style={{ animation: "fadeIn 1s" }}  >
                                        <tbody>
                                            <tr>
                                                <td>Тестовое приложение</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="lwocrypt.apk"
                                                        value="android"
                                                        disabled={this.state.isLoading.android_test_apk}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'android_test_apk')}>
                                                        {!this.state.isLoading.android_test_apk ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>AAR библиотека</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="lcryptowrap.aar"
                                                        value="android"
                                                        disabled={this.state.isLoading.android_aar}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'android_aar')}>
                                                        {!this.state.isLoading.android_aar ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Проект сборки AAR библиотеки</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="lcryptowrap_android.zip"
                                                        value="android"
                                                        disabled={this.state.isLoading.android_prj_aar}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'android_prj_aar')}>
                                                        {!this.state.isLoading.android_prj_aar ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Пример проекта подключения AAR библиотеки</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="MyApplication2.zip"
                                                        value="android"
                                                        disabled={this.state.isLoading.android_example_prj_aar}
                                                        onClick={e => this.onClickLWOCryptDownload(e, 'android_example_prj_aar')}>
                                                        {!this.state.isLoading.android_example_prj_aar ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div> : null
                            }
                        </Alert>

                    </div> : null
                }
            </Alert>
        );
    }
}

export default LWOCryptBlock;
